import { render, staticRenderFns } from "./PageTemplate.vue?vue&type=template&id=563d7258&scoped=true&"
import script from "./PageTemplate.vue?vue&type=script&lang=js&"
export * from "./PageTemplate.vue?vue&type=script&lang=js&"
import style0 from "./PageTemplate.vue?vue&type=style&index=0&id=563d7258&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563d7258",
  null
  
)

export default component.exports